// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  apiUrl: 'https://sss-api.goldenfinancing.com/api/v1/',
  domain: '.goldenfinancing.com',
  path: '/',
  imgfile_limit: {limit: 5242880, name: '5MB', filetype: ['image/jpeg','image/jpg']},
  videofile_limit: {limit:52428800, name: '50MB', filetype: ['video/mp4']}, // 50mb
  audiofile_limit: {
    limit:52428800,  // 50mb
    name: '50MB', 
    filetype: ['audio/mp3', 'audio/mpeg', 'video/mp4', 'audio/aac', 'audio/x-m4a']},
};



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/environments/environment.ts